import { Plus, Minus } from "@chef/icons/small";
import { ProductsByCategoriesQuery } from "@chef/state-management";
import {
  getPriceOfProductByVariation,
  getStockData,
  getBasketProductQuantity,
} from "@chef/state-management/helpers";
import { useStandaloneBasket } from "@chef/state-management/hooks";
import { ButtonCircle } from "@chef/components";

type ControlsProps = {
  variation: ProductsByCategoriesQuery["productsByCategories"][number]["products"][number]["variations"][number];
  basketType: "billing" | "deviation";
  week?: number;
  year?: number;
};

export const Controls = (props: ControlsProps) => {
  const { variation, basketType, week, year } = props;
  const { basket, addToBasket, removeFromBasket } = useStandaloneBasket({
    variant: basketType,
    week,
    year,
  });

  const productId = variation.product.productId;
  const variationId = variation.variationId;
  const price = getPriceOfProductByVariation(variation);
  const productTypeId = variation.product.productTypeId;
  const id = `${productId}:${variationId}`;

  const basketQuantity = getBasketProductQuantity(
    basket,
    productId,
    variationId,
  );

  const { maxPurchasableAmount } = getStockData({
    variation,
    addedQuantity: basketQuantity,
  });

  const onDecrementItem = () => {
    removeFromBasket({
      productId,
      productTypeId,
      variationId,
      price,
    });
  };

  const onIncrementItem = () => {
    addToBasket({
      productId,
      productTypeId,
      variationId,
      price,
    });
  };

  return (
    <div className="flex items-center">
      {!!basketQuantity && (
        <>
          <ButtonCircle
            small
            onClick={onDecrementItem}
            Icon={Minus}
            id={`${id}-minus-btn`}
          />
          <span className="mx-2">{basketQuantity}</span>
        </>
      )}
      <ButtonCircle
        small
        outlined={!!basketQuantity}
        primary
        onClick={onIncrementItem}
        Icon={Plus}
        id={`${id}-add-btn`}
        disabled={basketQuantity >= maxPurchasableAmount}
      />
    </div>
  );
};
